export default __webpack_public_path__ + "static/media/dot.d4a105dc.svg";